<template>
<!--  <div class="form-group">-->
<!--    <label class="form-label">Номер мобильного телефона заявителя*</label>-->
<!--    <Inputmask name="telephone" mask="+7 (999) 999-99-99" v-model="telephone"/>-->
<!--    <p-->
<!--        v-for="(error, index) of v$.telephone.$errors"-->
<!--        :key="index"-->
<!--    ><strong class="error-message">{{error.$message}}</strong></p>-->
<!--  </div>-->
  <InputWithLabel
      type="tel"
      name="telephone"
      mask="+7 (999) 999-99-99"
      :errors="v$.telephone.$errors"
      v-model="telephone"
      @blur="v$.telephone.$touch"
      scroll-into-view-if-errors
  >
    Номер мобильного телефона заявителя*
  </InputWithLabel>

  <InputWithLabel
      type="email"
      name="email"
      :errors="v$.email.$errors"
      v-model="email"
      @blur="v$.email.$touch"
      scroll-into-view-if-errors
  >
    Адрес электронной почты*
  </InputWithLabel>
</template>

<script>
import * as mns from "@/store/mutation-types";
import useVuelidate from "@vuelidate/core";
import {required, email, helpers} from "@vuelidate/validators";
import {russiaNumber} from "@/validators/telephone-validators";
import InputWithLabel from "@/components/utils/InputWithLabel";

export default {
  anotherNameLife: "InsuredPerson",
  components: {
    InputWithLabel,
  },
  data(){
    return {
      v$: useVuelidate(),
    }
  },
  validations(){
    return {
      telephone: {
        russiaNumber: helpers.withMessage('Неверный формат', russiaNumber)
      },
      email: {
        required: helpers.withMessage('Поле должно быть заполнено', required),
        email: helpers.withMessage('Неверный формат', email),
      },
    }
  },
  computed: {
    telephone: {
      get(){
        return this.$store.getters.telephone;
      },
      set(value){
        this.$store.commit(mns.SET_TELEPHONE, value)
      }
    },
    email: {
      get(){
        return this.$store.getters.email;
      },
      set(value){
        this.$store.commit(mns.SET_EMAIL, value)
      }
    },
  }
}
</script>

<style scoped>

</style>